import React, { useEffect, useRef, useState } from 'react';
// @mui
import { Stack, TextField, Grid, Autocomplete, FormControlLabel, Checkbox } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import "../../../sections/auth/login/login.css"
import { toast, ToastContainer } from 'react-toastify';
import { postData, validatePostData } from 'src/webService/webService';
import { countries } from "country-data";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import uploadIcon from '../../../components/icons/user-dark.png';
import { auth, RecaptchaVerifier, signInWithPhoneNumber } from 'src/sections/fireBase/fireBase';
import loader from '../../../components/icons/loads.gif';
import Iconify from 'src/components/iconify';

export default function WebsiteLoginForm() {
    const [response, setResponse] = useState('');
    const [otp, setOtp] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [countryCode, setCountryCode] = useState('+91');
    const [name, setName] = useState('');
    const [profilePicture, setProfilePicture] = useState('');
    const [whatsapp_countrycode, setWhatsapp_countrycode] = useState('+91');
    const [whatsAppNumber, setWhatsAppNumber] = useState('');
    const [email, setEmail] = useState('');
    const [confirmationResult, setConfirmationResult] = useState(null);
    const [register, setRegister] = useState('');
    const initialImage = uploadIcon;
    const [preview, setPreview] = useState(initialImage);
    const [isTermsAccepted, setIsTermsAccepted] = useState(false);
    const navigate = useNavigate();


    const dialCodes = countries.all.map(c => ({
        dialCode: c.countryCallingCodes[0],
    }));

    const validDialCodes = dialCodes
        .filter(item => item.dialCode && item.dialCode.trim() !== '')
        .map(item => item.dialCode);

    const inputRefs = useRef([]);

    const handleChange = (e, index) => {
        const { value } = e.target;
        if (/^[0-9]?$/.test(value)) {
            const otpArray = otp.split('');
            otpArray[index] = value;
            const newOtp = otpArray.join('').padEnd(6, '');
            setOtp(newOtp);
        }
        // const value = e.target.value;
        // if (!/^[0-9]?$/.test(value)) return; // only allow digits

        // const newOtp = [...otp];
        // newOtp[index] = value;
        // setOtp(newOtp);

        if (value && index < inputRefs.current.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };



    const handleSubmit = (e) => {
        e.preventDefault();
        setRegister('register');
        if (!isTermsAccepted) {
            toast.error("Please accept the Terms and Conditions to proceed.");
            return;
        }
        const MobileValidation = {
            phone: mobileNo,
        }
        sendOTP()

    }

    const handleLogin = () => {
        const confirmOtp = {
            otp: otp
        }
        console.log(confirmOtp, 'confirmOTP');

        // if (confirmOtp.otp === '123456') {
        //     sessionStorage.setItem('Role', 'Buyer')
        //     navigate("/home", { replace: true });
        // }
        verifyOTP();

    }

    // const sendOTP = async () => {
    //     debugger
    //     window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
    //         size: 'invisible',
    //     });

    //     try {
    //         const result = await signInWithPhoneNumber(auth, mobileNo, window.recaptchaVerifier);
    //         setConfirmationResult(result);
    //         alert("OTP sent!");
    //         setResponse('Login active')
    //     } catch (error) {
    //         console.error("Error sending OTP", error);
    //     }
    // };

    const [disable, setDisable] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [loaderLabel, setLoaderLabel] = useState('');

    const sendOTP = async () => {
        try {
            setLoaderLabel('Sending OTP');
            setIsLoading(true);
            if (!window.recaptchaVerifier) {
                window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
                    size: 'invisible',
                    callback: (response) => {
                        // reCAPTCHA solved, allow signInWithPhoneNumber.
                        console.log("reCAPTCHA solved", response);
                    },
                    'expired-callback': () => {
                        console.warn("reCAPTCHA expired");
                    }
                });
            }

            const result = await signInWithPhoneNumber(auth, `${countryCode}${mobileNo}`, window.recaptchaVerifier);
            setConfirmationResult(result);
            setDisable(!disable);
            if (response === 'Login does not exists') {
                setResponse('Login active');
            }
            // alert("OTP sent!");
        } catch (error) {
            console.error("Error sending OTP", error);
            toast.error("Error sending OTP. Please try again");
        }
        setIsLoading(false);
    };


    const verifyOTP = async () => {
        try {
            const result = await confirmationResult.confirm(otp);
            const idToken = await result.user.getIdToken();
            const uuid = await result.user?.uid;
            console.log(idToken, 'idTokenidTokenidTokenidToken');

            // Send ID token to backend
            // const res = await fetch("http://your-laravel-api.com/api/firebase-login", {
            //     method: "POST",
            //     headers: { "Content-Type": "application/json" },
            //     body: JSON.stringify({ firebase_token: idToken }),
            // });

            // const data = await res.json();
            // console.log("Laravel user login response", data);

            if (register === 'register') {
                const params = {
                    name: name,
                    phone: mobileNo,
                    uuid: uuid,
                    isWeb: true,
                    whatsapp: whatsAppNumber,
                    whatsapp_countrycode: whatsapp_countrycode,
                    phone_countrycode: countryCode,
                    photo: profilePicture,
                    web_fcm_token: idToken
                }
                const res = await postData('auth/buyer/register', params, null)

                console.log(res, 'ressssssssssss');
                if (res.status === 201) {
                    sessionStorage.setItem('BuyerName', res?.name)
                    sessionStorage.setItem('Role', 'Buyer')
                    sessionStorage.setItem("Token", `Bearer ${res?.token}`);
                    navigate("/categories", { replace: true });
                }

            } else {
                const params = {
                    phone: `${countryCode}${mobileNo}`,
                    uuid: uuid,
                    isWeb: true,
                    web_fcm_token: idToken
                }

                const res = await postData('auth/buyer/login', params, null)

                console.log(res, 'ressssssssssss');
                if (res.status === 200) {
                    sessionStorage.setItem('BuyerName', res?.user?.name)
                    sessionStorage.setItem('Role', 'Buyer')
                    sessionStorage.setItem("Token", `Bearer ${res?.token}`);
                    navigate("/categories", { replace: true });
                }
            }





        } catch (error) {
            console.error("Invalid OTP", error);
            toast.error("Error on validating OTP. Please try again");
        }
        setIsLoading(false);
        setRegister('');

    };

    const handleClick = (e, status) => {
        setLoaderLabel('Login Verifying');
        setIsLoading(true);
        e.preventDefault();
        const MobileValidation = {
            phone: `${countryCode}${mobileNo}`,
        }

        if (mobileNo === '') {
            toast.error("Mobile Number is Required");
            setIsLoading(false);
        } else {
            validatePostData("auth/buyer/validate", MobileValidation, null)
                .then((res) => {
                    setResponse(res?.message);
                    console.log(res.status === 200);
                    console.log(res);
                    switch (res.status) {
                        case 200:
                            sendOTP();
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                    toast.error("Cant able to login right now. Please try again");
                });
            setIsLoading(false);
        }
    }

    console.log(response, 'responseresponseresponse');

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setProfilePicture(file)
        }
    };


    return (
        <>
            <ToastContainer position='top-right' />
            <div id='recaptcha-container'></div>
            <Stack spacing={3}>
                {response === 'Login does not exists' ? (
                    <>
                        <h4 className='text-center'>REGISTER</h4>
                        <p className='mt-1 fs-14 text-center' style={{ color: 'red' }}>Looks like this mobile number isn’t registered yet. Go ahead and register to get started!</p>
                    </>
                ) : (
                    <div style={{ position: 'relative' }}>
                        <h4 className='text-center'>LOG IN</h4>
                    </div>
                )}
                {response === 'Login active' ? (
                    <Grid container spacing={1}>
                        {Array.from({ length: 6 }).map((_, index) => (
                            <Grid item xs={2} className="mt-3" key={index}>
                                <TextField
                                    inputRef={(el) => (inputRefs.current[index] = el)}
                                    className="w-100"
                                    name={`otp-${index}`}
                                    value={otp[index] || ''}
                                    onChange={(e) => handleChange(e, index)}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    autoComplete="off"
                                    required
                                    // InputLabelProps={{ shrink: true }}
                                    disabled={disable}
                                    inputProps={{
                                        maxLength: 1,
                                        style: { textAlign: 'center' },
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>
                ) : response === 'Login does not exists' ? (
                    <Grid container spacing={1}>
                        <Grid item xs={12} className='mt-1'>
                            <TextField
                                className="w-100"
                                name="name"
                                label="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                autoComplete="off"
                                required
                            // InputLabelProps={{
                            //     shrink: true,
                            // }}
                            />
                        </Grid>
                        <Grid item xs={12} className='mt-3'>
                            <TextField
                                className="w-100"
                                name="email"
                                label="Email Id"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                autoComplete="off"
                                required
                            // InputLabelProps={{
                            //     shrink: true,
                            // }}
                            />
                        </Grid>
                        <Grid item xs={4} className='mt-3'>
                            <Autocomplete
                                options={validDialCodes}
                                value={countryCode}
                                onChange={(event, newValue) => setCountryCode(newValue)}
                                renderInput={(params) => <TextField {...params} label="Country Code *" />}
                            // InputLabelProps={{
                            //     shrink: true,
                            // }}
                            />
                        </Grid>
                        <Grid item xs={8} className='mt-3'>
                            <TextField
                                className="w-100"
                                name="mobileNo"
                                label="Mobile Number"
                                value={mobileNo}
                                onChange={(e) => setMobileNo(e.target.value)}
                                autoComplete="off"
                                required
                            // InputLabelProps={{
                            //     shrink: true,
                            // }}
                            />
                        </Grid>
                        <Grid item xs={4} className='mt-3'>
                            <Autocomplete
                                options={validDialCodes}
                                value={whatsapp_countrycode}
                                onChange={(event, newValue) => setWhatsapp_countrycode(newValue)}
                                renderInput={(params) => <TextField {...params} label="Country Code *" />}
                            // InputLabelProps={{
                            //     shrink: true,
                            // }}
                            />
                        </Grid>
                        <Grid item xs={8} className='mt-3'>
                            <TextField
                                className="w-100"
                                name="whatsAppNumber"
                                label="Whatsapp Number"
                                value={whatsAppNumber}
                                onChange={(e) => setWhatsAppNumber(e.target.value)}
                                autoComplete="off"
                                required
                            // InputLabelProps={{
                            //     shrink: true,
                            // }}
                            />
                        </Grid>
                        <Grid item xs={12} className='mt-3'>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isTermsAccepted}
                                        onChange={(e) => setIsTermsAccepted(e.target.checked)}
                                        name="terms"
                                        required
                                    />
                                }
                                label="I agree to the Terms and Conditions"
                            />
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container spacing={1}>
                        <Grid item xs={4} className='mt-3'>
                            <Autocomplete
                                options={validDialCodes}
                                value={countryCode}
                                onChange={(event, newValue) => setCountryCode(newValue)}
                                renderInput={(params) => <TextField {...params} label="Country Code *" />}
                            // InputLabelProps={{
                            //     shrink: true,
                            // }}
                            />
                        </Grid>
                        <Grid item xs={8} className='mt-3'>
                            <TextField
                                className="w-100"
                                name="mobileNo"
                                label="Mobile Number"
                                value={mobileNo}
                                onChange={(e) => setMobileNo(e.target.value)}
                                autoComplete="off"
                                required
                            // InputLabelProps={{
                            //     shrink: true,
                            // }}
                            />
                        </Grid>
                    </Grid>

                )}
            </Stack>
            {isLoading ? GetLoader() :
                (response === 'Login active') ? (
                    <LoadingButton fullWidth size="large" type="submit" variant="contained" sx={{ my: 2 }} onClick={handleLogin}>
                        Login
                    </LoadingButton>
                ) : response === 'Login does not exists' ? (
                    <LoadingButton fullWidth size="large" type="submit" variant="contained" sx={{ my: 2 }} onClick={handleSubmit}>
                        Submit
                    </LoadingButton>
                ) : (
                    <LoadingButton fullWidth size="large" type="submit" variant="contained" sx={{ my: 2 }} onClick={handleClick}>
                        Send OTP
                    </LoadingButton>
                )}


            <Link className="nav-link text-center" to="/home">
                <Iconify icon="eva:arrow-circle-left-outline" sx={{ mr: 1 }} />  Back to home
            </Link>
        </>
    );

    function GetLoader() {
        return <>
            <div className='d-flex' style={{ textAlign: 'center', padding: '20px' }}>
                <img width='10%' src={loader} alt="Loading..." />
                {loaderLabel}
            </div>
        </>
    }
}